import React from 'react';
import { 
  UserIcon,
  ClockIcon,
  TruckIcon,
  CurrencyEuroIcon,
  ClipboardDocumentListIcon,
  CheckCircleIcon,
  DocumentTextIcon,
  PencilIcon,
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
  ArrowLeftIcon,
  PhoneIcon,
  EnvelopeIcon,
  PrinterIcon
} from '@heroicons/react/24/outline';
import API_CONFIG from '../../config/api';

const TabRiepilogo = ({ 
  pratica, 
  getAgenziaName, 
  getAgenteName, 
  formatDate,
  ruoloUtente,
  onAzioniDisponibili,
  isOfferteTabDisabled,
  canAssegnareAgenti,
  user,
  contratti = []
}) => {
  if (!pratica) return null;

  // Determina le azioni disponibili per lo stato corrente
  const getAzioniDisponibili = () => {
    const stato = pratica.stato || pratica.statoPratica;
    
    // Determina se l'utente può vedere azioni dell'agenzia
    const ruoloReale = user?.role || user?.ruolo || 'agente';
    const isAgenteOAgenzia = ruoloUtente === 'agente' || 
                             ruoloReale === 'agenzia' || 
                             ruoloReale === 'team_leader' || 
                             ruoloReale === 'subagente' || 
                             ruoloReale === 'segnalatore';
    const isAdmin = ruoloUtente === 'admin' || ruoloReale === 'admin';

    const azioni = [];

    switch (stato) {
      case 'pratica_avviata':
        if (isAgenteOAgenzia) {
          // Azioni prioritarie per agenzia
          azioni.push(
            { 
              id: 'modifica_cliente', 
              label: 'Verifica/Aggiorna Dati Cliente', 
              icon: UserIcon, 
              color: 'blue',
              priorita: 'alta',
              descrizione: 'Verifica correttezza dati anagrafici e aggiorna se necessario'
            },
            { 
              id: 'seleziona_offerta', 
              label: 'Seleziona Offerta Compatibile', 
              icon: CheckCircleIcon, 
              color: 'green',
              priorita: 'alta',
              descrizione: 'Scegli l\'offerta più adatta alle esigenze del cliente'
            }
          );

          // Aggiungi azione assegnazione agente solo se l'utente ha i permessi
          if (canAssegnareAgenti && canAssegnareAgenti()) {
            azioni.push({ 
              id: 'assegna_agente', 
              label: 'Assegna Agente Specifico', 
              icon: UserIcon, 
              color: 'purple',
              priorita: 'media',
              descrizione: 'Assegna la pratica a un agente specifico del team'
            });
          }
          
          // Solo se le offerte non sono disabilitate
          if (!isOfferteTabDisabled || !isOfferteTabDisabled()) {
            azioni.push(
              { 
                id: 'preventivi', 
                label: 'Richiedi Preventivo Personalizzato', 
                icon: DocumentTextIcon, 
                color: 'purple',
                priorita: 'media',
                descrizione: 'Crea preventivo personalizzato per esigenze specifiche'
              }
            );
          }
        }
        
        if (isAdmin) {
          azioni.push(
            { 
              id: 'modifica_cliente', 
              label: 'Modifica Dati Cliente', 
              icon: UserIcon, 
              color: 'indigo',
              priorita: 'media',
              descrizione: 'Correzione dati anagrafici se necessario'
            },
            { 
              id: 'riassegna_agenzia', 
              label: 'Riassegna ad Altra Agenzia', 
              icon: BuildingOfficeIcon, 
              color: 'orange',
              priorita: 'bassa',
              descrizione: 'Trasferisci pratica a diversa agenzia/agente'
            }
          );

          // Aggiungi azione assegnazione agente solo se l'utente ha i permessi
          if (canAssegnareAgenti && canAssegnareAgenti()) {
            azioni.push({ 
              id: 'assegna_agente', 
              label: 'Assegna Agente Specifico', 
              icon: UserIcon, 
              color: 'blue',
              priorita: 'media',
              descrizione: 'Assegna pratica a un agente specifico'
            });
          }
        }
        break;

      case 'attesa_preventivo':
        if (isAgenteOAgenzia) {
          azioni.push(
            { id: 'preventivi', label: 'Richiedi Altri Preventivi', icon: DocumentTextIcon, color: 'blue' },
            { id: 'modifica_preventivo', label: 'Modifica Richiesta', icon: PencilIcon, color: 'yellow' }
          );
        }
        if (isAdmin) {
          azioni.push(
            { id: 'conferma_preventivo', label: 'Conferma Preventivo', icon: CheckCircleIcon, color: 'green' },
            { id: 'modifica_preventivo', label: 'Modifica Richiesta', icon: PencilIcon, color: 'yellow' }
          );
        }
        break;

      case 'attesa_approvazione_cliente':
        if (isAgenteOAgenzia) {
          azioni.push(
            { id: 'conferma_cliente', label: 'Cliente Approva', icon: CheckCircleIcon, color: 'green' },
            { id: 'richiedi_modifica_cliente', label: 'Cliente Richiede Modifiche', icon: PencilIcon, color: 'yellow' }
          );
        }
        break;

      case 'valutazione_cliente':
        if (isAgenteOAgenzia) {
          azioni.push(
            { id: 'conferma_cliente', label: 'Conferma Cliente', icon: CheckCircleIcon, color: 'green' },
            { id: 'torna_pratica_avviata', label: 'Torna a Pratica Avviata', icon: ArrowLeftIcon, color: 'orange', descrizione: 'Riporta la pratica allo stato iniziale per creare nuovi preventivi' }
          );
        }
        break;

      case 'attesa_documenti_cliente':
        if (isAgenteOAgenzia) {
          azioni.push(
            { id: 'carica_documenti', label: 'Carica Documenti', icon: DocumentTextIcon, color: 'blue' },
            { id: 'gestisci_documenti', label: 'Gestisci Documenti', icon: ClipboardDocumentListIcon, color: 'indigo' },
            { id: 'torna_pratica_avviata', label: 'Torna a Pratica Avviata', icon: ArrowLeftIcon, color: 'orange', descrizione: 'Riporta la pratica allo stato iniziale per creare nuovi preventivi' }
          );
        }
        break;

      case 'richiesta_esito':
        if (isAdmin) {
          azioni.push(
            { id: 'approva_documenti', label: 'Approva Documenti', icon: CheckCircleIcon, color: 'green' },
            { id: 'richiedi_integrazione', label: 'Richiedi Integrazione', icon: ExclamationTriangleIcon, color: 'yellow' }
          );
        }
        break;

      case 'pratica_in_valutazione':
        if (isAdmin) {
          azioni.push(
            { id: 'approva_pratica', label: 'Approva Pratica', icon: CheckCircleIcon, color: 'green' },
            { id: 'condiziona_pratica', label: 'Condiziona Pratica', icon: ExclamationTriangleIcon, color: 'yellow' },
            { id: 'rifiuta_pratica', label: 'Rifiuta Pratica', icon: XMarkIcon, color: 'red' },
            { id: 'richiedi_integrazione', label: 'Richiedi Integrazione', icon: ExclamationTriangleIcon, color: 'yellow' }
          );
        }
        break;

      case 'condizionata':
        if (isAdmin) {
          azioni.push(
            { id: 'prosegui_da_condizionata', label: 'Prosegui verso contratto', icon: CheckCircleIcon, color: 'green' },
            { id: 'chiudi_condizionata', label: 'Chiudi con esito negativo', icon: XMarkIcon, color: 'red' }
          );
        }
        break;

      case 'attesa_firma_contratto':
        console.log('DEBUG attesa_firma_contratto in TabRiepilogo:', { 
          isAdmin, 
          contratti,
          contrattiLength: contratti.length 
        });
        
        if (isAdmin) {
          azioni.push(
            { id: 'carica_contratto', label: 'Carica Contratto', icon: DocumentTextIcon, color: 'blue' }
          );
          
          // Se c'è un contratto firmato, mostra l'azione "Attiva Contratto"
          const hasContrattoFirmato = contratti.some(c => c.tipo === 'contratto_firmato');
          console.log('DEBUG hasContrattoFirmato:', hasContrattoFirmato);
          
          if (hasContrattoFirmato) {
            console.log('Aggiungo azione Attiva Contratto in TabRiepilogo');
            azioni.push(
              { id: 'attiva_contratto', label: 'Attiva Contratto', icon: CheckCircleIcon, color: 'green' }
            );
          }
        }
        if (isAgenteOAgenzia) {
          azioni.push(
            { id: 'scarica_contratto', label: 'Scarica Contratto', icon: ArrowLeftIcon, color: 'indigo' },
            { id: 'carica_firmato', label: 'Carica Contratto Firmato', icon: CheckCircleIcon, color: 'green' }
          );
        }
        break;

      case 'verifica_contratto':
        if (isAdmin) {
          azioni.push(
            { id: 'attiva_contratto', label: 'Attiva Contratto', icon: CheckCircleIcon, color: 'green' },
            { id: 'modifica_contratto', label: 'Modifica Dati Contratto', icon: PencilIcon, color: 'yellow' }
          );
        }
        break;
    }

    return azioni;
  };

  const handleAzione = (azioneId) => {
    if (onAzioniDisponibili) {
      onAzioniDisponibili(azioneId);
    }
  };

  const azioniDisponibili = getAzioniDisponibili();

  // Funzione per calcolare la temperatura della lead in tempo reale
  const calcolaTemperaturaLead = (dataCreazione, oraCreazione) => {
    try {
      // Combina data e ora per creare un timestamp completo
      const dataOraCreazione = new Date(`${dataCreazione}T${oraCreazione || '00:00:00'}`);
      const ora = new Date();
      
      // Calcola la differenza in ore
      const differenzaOre = Math.floor((ora - dataOraCreazione) / (1000 * 60 * 60));
      
      // Logica per determinare la temperatura:
      // - Caldo: meno di 24 ore (1 giorno)
      // - Tiepido: da 24 ore a 72 ore (1-3 giorni)  
      // - Freddo: più di 72 ore (più di 3 giorni)
      
      if (differenzaOre < 24) {
        return 'Caldo';
      } else if (differenzaOre <= 72) { // 3 giorni = 72 ore
        return 'Tiepido';
      } else {
        return 'Freddo';
      }
    } catch (error) {
      console.error('Errore nel calcolo della temperatura:', error);
      return 'Tiepido'; // Valore di fallback
    }
  };

  // Funzione per ottenere il colore e l'icona della temperatura
  const getTemperaturaInfo = (temperatura) => {
    switch (temperatura) {
      case 'Caldo':
        return {
          color: 'text-red-600 bg-red-50',
          icon: '',
          badge: 'bg-red-100 text-red-800'
        };
      case 'Tiepido':
        return {
          color: 'text-orange-600 bg-orange-50',
          icon: '',
          badge: 'bg-orange-100 text-orange-800'
        };
      case 'Freddo':
        return {
          color: 'text-blue-600 bg-blue-50',
          icon: '',
          badge: 'bg-blue-100 text-blue-800'
        };
      default:
        return {
          color: 'text-gray-600 bg-gray-50',
          icon: '',
          badge: 'bg-gray-100 text-gray-800'
        };
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      
      {/* Colonna Sinistra - Anagrafica Cliente */}
      <div className="space-y-6">
        
        {/* Informazioni Cliente */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="px-6 py-4 border-b bg-gray-50">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <UserIcon className="h-5 w-5 mr-2 text-blue-600" />
              Informazioni Cliente
            </h3>
          </div>
          <div className="p-6">
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500">Tipo Cliente:</label>
                <p className="text-sm font-medium text-gray-900 capitalize">
                  {pratica.cliente?.tipo_cliente || 'Non specificato'}
                </p>
              </div>
              
              {pratica.cliente?.ragione_sociale ? (
                <div>
                  <label className="text-sm font-medium text-gray-500">Ragione Sociale:</label>
                  <p className="text-sm font-medium text-gray-900">{pratica.cliente.ragione_sociale}</p>
                </div>
              ) : (
                <>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Nome:</label>
                    <p className="text-sm font-medium text-gray-900">
                      {pratica.cliente?.nome || 'Non specificato'}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Cognome:</label>
                    <p className="text-sm font-medium text-gray-900">
                      {pratica.cliente?.cognome || 'Non specificato'}
                    </p>
                  </div>
                </>
              )}
              
              <div>
                <label className="text-sm font-medium text-gray-500">Email:</label>
                <p className="text-sm font-medium text-gray-900">
                  {pratica.cliente?.email || 'Non specificata'}
                </p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-gray-500">Telefono:</label>
                <p className="text-sm font-medium text-gray-900">
                  {pratica.cliente?.telefono || 'Non specificato'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="px-6 py-4 border-b bg-gray-50">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <ClockIcon className="h-5 w-5 mr-2 text-blue-600" />
              Timeline
            </h3>
          </div>
          <div className="p-6">
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                <div>
                  <p className="text-sm font-medium text-gray-900">Pratica assegnata</p>
                  <p className="text-xs text-gray-500">{formatDate(pratica.dataAssegnazione)}</p>
                </div>
              </div>
              
              {pratica.dataUltimaModifica !== pratica.dataAssegnazione && (
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-green-500 rounded-full mt-2"></div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">Ultima modifica</p>
                    <p className="text-xs text-gray-500">{formatDate(pratica.dataUltimaModifica)}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Colonna Centrale - Veicoli e Preventivi */}
      <div className="space-y-6">
        
        {(() => {
          const preventivi = pratica.preventivi || [];

          // Ordine di priorita per lo stato: prima accettato, poi confermato, inviato, ecc.
          const ordinePriorita = ['accettato', 'confermato', 'inviato', 'in_attesa', 'bozza', 'richiesta_modifica', 'rifiutato', 'scaduto'];
          const preventiviOrdinati = [...preventivi].sort((a, b) => {
            const idxA = ordinePriorita.indexOf(a.statoPreventivo);
            const idxB = ordinePriorita.indexOf(b.statoPreventivo);
            return (idxA === -1 ? 99 : idxA) - (idxB === -1 ? 99 : idxB);
          });

          const preventivoAttivo = preventivi.find(p => p.statoPreventivo === 'accettato') 
            || preventivi.find(p => p.statoPreventivo === 'confermato');

          // Helper per badge stato preventivo
          const getStatoBadge = (stato) => {
            const statiMap = {
              'accettato': { label: 'Accettato', colore: 'bg-green-100 text-green-800' },
              'confermato': { label: 'Confermato', colore: 'bg-blue-100 text-blue-800' },
              'inviato': { label: 'Inviato', colore: 'bg-yellow-100 text-yellow-800' },
              'bozza': { label: 'Bozza', colore: 'bg-gray-100 text-gray-800' },
              'in_attesa': { label: 'In attesa', colore: 'bg-orange-100 text-orange-800' },
              'rifiutato': { label: 'Rifiutato', colore: 'bg-red-100 text-red-800' },
              'scaduto': { label: 'Scaduto', colore: 'bg-gray-100 text-gray-500' },
              'richiesta_modifica': { label: 'Modifica richiesta', colore: 'bg-purple-100 text-purple-800' }
            };
            return statiMap[stato] || { label: stato, colore: 'bg-gray-100 text-gray-800' };
          };

          // Helper per estrarre dati offerta dal preventivo
          const getDatiOfferta = (preventivo) => {
            if (!preventivo?.datiOfferta) return null;
            try {
              const dati = typeof preventivo.datiOfferta === 'string' 
                ? JSON.parse(preventivo.datiOfferta) 
                : preventivo.datiOfferta;
              return dati;
            } catch { return null; }
          };

          // Card singolo preventivo
          const PreventivoCard = ({ preventivo, attivo }) => {
            const vettura = preventivo.vettura;
            const badge = getStatoBadge(preventivo.statoPreventivo);
            const datiOfferta = getDatiOfferta(preventivo) || preventivo.offerta;

            return (
              <div className={`rounded-lg border p-4 ${attivo ? 'border-green-400 bg-green-50/40' : 'border-gray-200'}`}>
                <div className="flex items-start gap-4">
                  {/* Immagine vettura */}
                  {vettura?.immagine?.path_file && (
                    <div className="flex-shrink-0">
                      <img
                        src={`${API_CONFIG.baseURL}${vettura.immagine.path_file}`}
                        alt={`${vettura.brand} ${vettura.modello}`}
                        className="w-28 h-20 object-cover rounded-lg"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    </div>
                  )}

                  {/* Contenuto */}
                  <div className="flex-1 min-w-0">
                    {/* Riga intestazione: nome veicolo + badge stato */}
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <p className="text-base font-bold text-gray-900 truncate">
                        {vettura?.brand || '—'} {vettura?.modello || ''}
                      </p>
                      <span className={`flex-shrink-0 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${badge.colore}`}>
                        {badge.label}
                      </span>
                    </div>

                    {/* Tipo e ID preventivo */}
                    <p className="text-xs text-gray-500 mb-2">
                      Preventivo #{preventivo.id} — <span className="capitalize">{preventivo.tipoPreventivo?.replace('_', ' ') || 'Standard'}</span>
                      {vettura?.alimentazione && <span className="ml-2 text-gray-400">| {vettura.alimentazione}</span>}
                    </p>

                    {/* Dati offerta compatti */}
                    {datiOfferta && (
                      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                        {(datiOfferta.canone || datiOfferta.canone_mensile) && (
                          <span>
                            <span className="text-gray-500">Canone:</span>{' '}
                            <span className="font-semibold text-blue-600">
                              {parseFloat(datiOfferta.canone || datiOfferta.canone_mensile || 0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}/mese
                            </span>
                          </span>
                        )}
                        {(datiOfferta.durata || datiOfferta.durata_mesi) && (
                          <span>
                            <span className="text-gray-500">Durata:</span>{' '}
                            <span className="font-semibold text-gray-800">{datiOfferta.durata || datiOfferta.durata_mesi} mesi</span>
                          </span>
                        )}
                        {(datiOfferta.kmAnnui || datiOfferta.km_annui) && (
                          <span>
                            <span className="text-gray-500">Km/anno:</span>{' '}
                            <span className="font-semibold text-gray-800">{parseInt(datiOfferta.kmAnnui || datiOfferta.km_annui || 0).toLocaleString()}</span>
                          </span>
                        )}
                        {datiOfferta.anticipo && parseFloat(datiOfferta.anticipo) > 0 && (
                          <span>
                            <span className="text-gray-500">Anticipo:</span>{' '}
                            <span className="font-semibold text-green-600">
                              {parseFloat(datiOfferta.anticipo).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
                            </span>
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          };

          return (
            <div className="bg-white rounded-lg shadow-sm border">
              {/* Intestazione */}
              <div className="px-6 py-4 border-b bg-gray-50 flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <TruckIcon className="h-5 w-5 mr-2 text-blue-600" />
                  Veicoli e Preventivi
                </h3>
                {preventivi.length > 0 && (
                  <span className="text-xs text-gray-500">{preventivi.length} preventiv{preventivi.length === 1 ? 'o' : 'i'}</span>
                )}
              </div>

              <div className="p-4 space-y-3">
                {/* Richiesta iniziale del cliente (vettura/offerta della pratica) — solo se non ha preventivi o se il veicolo e diverso da tutti i preventivi */}
                {pratica.vettura && (preventivi.length === 0 || (preventivi.length > 0 && !preventivi.some(p => p.vettura && p.vettura.id === pratica.vettura.id))) && (
                  <div className="rounded-lg border border-dashed border-gray-300 p-4">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Richiesta iniziale del cliente</p>
                    <div className="flex items-start gap-4">
                      {pratica.vettura.immagine?.path_file && (
                        <img
                          src={`${API_CONFIG.baseURL}${pratica.vettura.immagine.path_file}`}
                          alt={`${pratica.vettura.brand} ${pratica.vettura.modello}`}
                          className="w-20 h-14 object-cover rounded-lg opacity-80"
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      )}
                      <div>
                        <p className="text-sm font-medium text-gray-700">{pratica.vettura.brand} {pratica.vettura.modello}</p>
                        {pratica.vettura.alimentazione && (
                          <p className="text-xs text-gray-400">{pratica.vettura.alimentazione}</p>
                        )}
                        {pratica.offerta && (
                          <p className="text-xs text-gray-500 mt-1">
                            {pratica.offerta.canone && <span>Canone: {parseFloat(pratica.offerta.canone).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}/mese</span>}
                            {pratica.offerta.durata && <span className="ml-2">| {pratica.offerta.durata} mesi</span>}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Lista preventivi ordinata per priorita */}
                {preventiviOrdinati.map(prev => (
                  <PreventivoCard 
                    key={prev.id} 
                    preventivo={prev} 
                    attivo={preventivoAttivo?.id === prev.id} 
                  />
                ))}

                {/* Nessun dato */}
                {!pratica.vettura && preventivi.length === 0 && (
                  <div className="py-8 text-center text-gray-400">
                    <TruckIcon className="h-10 w-10 mx-auto mb-2 text-gray-300" />
                    <p className="text-sm">Nessun veicolo ancora associato</p>
                    <p className="text-xs mt-1">Seleziona un'offerta per associare un veicolo</p>
                  </div>
                )}
              </div>
            </div>
          );
        })()}
      </div>

      {/* Colonna Destra - Informazioni Aggiuntive */}
      <div className="space-y-6">
        
        {/* Informazioni Pratica */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="px-6 py-4 border-b bg-gray-50">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <ClipboardDocumentListIcon className="h-5 w-5 mr-2 text-blue-600" />
              Dettagli Pratica
            </h3>
          </div>
          <div className="p-6">
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500">Agenzia Primaria:</label>
                <p className="text-sm font-medium text-gray-900">{getAgenziaName(pratica.idAgenziaPrimaria)}</p>
              </div>
              
              {pratica.idAgente && (
                <div>
                  <label className="text-sm font-medium text-gray-500">Agente Assegnato:</label>
                  <p className="text-sm font-medium text-gray-900">{getAgenteName(pratica.idAgente)}</p>
                </div>
              )}
              
              {pratica.dataScadenza && (
                <div>
                  <label className="text-sm font-medium text-gray-500">Scadenza:</label>
                  <p className="text-sm font-medium text-gray-900">{formatDate(pratica.dataScadenza)}</p>
                </div>
              )}
              
              {pratica.importoStimato && (
                <div>
                  <label className="text-sm font-medium text-gray-500">Importo Stimato:</label>
                  <p className="text-sm font-medium text-green-600">
                    € {parseFloat(pratica.importoStimato).toLocaleString()}
                  </p>
                </div>
              )}
              
              {pratica.provvigioneStimata && (
                <div>
                  <label className="text-sm font-medium text-gray-500">Provvigione Stimata:</label>
                  <p className="text-sm font-medium text-blue-600">
                    € {parseFloat(pratica.provvigioneStimata).toLocaleString()}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Azioni Disponibili */}
        {azioniDisponibili.length > 0 && (
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b bg-gray-50">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <CheckCircleIcon className="h-5 w-5 mr-2 text-blue-600" />
                Azioni Disponibili
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {pratica.stato === 'pratica_avviata' 
                  ? `Workflow ${ruoloUtente === 'agente' ? 'Agenzia' : 'Amministratore'} - Pratica Avviata`
                  : `Azioni disponibili per lo stato attuale come ${ruoloUtente}`
                }
              </p>
            </div>
            <div className="p-6">
              {pratica.stato === 'pratica_avviata' ? (
                // Layout specifico per Pratica Avviata con priorità
                <div className="space-y-4">
                  {/* Azioni ad alta priorità */}
                  {azioniDisponibili.filter(a => a.priorita === 'alta').length > 0 && (
                    <div>
                      <h4 className="text-sm font-semibold text-orange-800 mb-3 flex items-center">
                        <ExclamationTriangleIcon className="h-4 w-4 mr-1" />
                        Azioni Prioritarie
                      </h4>
                      <div className="space-y-2">
                        {azioniDisponibili.filter(a => a.priorita === 'alta').map((azione) => {
                          const IconComponent = azione.icon;
                          const colorClasses = {
                            blue: 'bg-blue-600 hover:bg-blue-700 text-white border-blue-700',
                            green: 'bg-green-600 hover:bg-green-700 text-white border-green-700',
                            yellow: 'bg-yellow-600 hover:bg-yellow-700 text-white border-yellow-700',
                            red: 'bg-red-600 hover:bg-red-700 text-white border-red-700',
                            indigo: 'bg-indigo-600 hover:bg-indigo-700 text-white border-indigo-700',
                            purple: 'bg-purple-600 hover:bg-purple-700 text-white border-purple-700',
                            orange: 'bg-orange-600 hover:bg-orange-700 text-white border-orange-700',
                            gray: 'bg-gray-600 hover:bg-gray-700 text-white border-gray-700'
                          };
                          
                          return (
                            <div key={azione.id} className="border-l-4 border-orange-400 bg-orange-50 p-3 rounded-r-lg">
                              <button
                                onClick={() => handleAzione(azione.id)}
                                className={`w-full px-4 py-3 rounded-lg flex items-center text-sm font-medium transition-colors ${colorClasses[azione.color] || colorClasses.blue}`}
                              >
                                <IconComponent className="h-5 w-5 mr-3" />
                                <div className="text-left flex-1">
                                  <div className="font-semibold">{azione.label}</div>
                                  {azione.descrizione && (
                                    <div className="text-xs opacity-90 mt-1">{azione.descrizione}</div>
                                  )}
                                </div>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Azioni a media priorità */}
                  {azioniDisponibili.filter(a => a.priorita === 'media').length > 0 && (
                    <div>
                      <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
                        <ClockIcon className="h-4 w-4 mr-1" />
                        Azioni Raccomandate
                      </h4>
                      <div className="space-y-2">
                        {azioniDisponibili.filter(a => a.priorita === 'media').map((azione) => {
                          const IconComponent = azione.icon;
                          const colorClasses = {
                            blue: 'bg-blue-600 hover:bg-blue-700 text-white',
                            green: 'bg-green-600 hover:bg-green-700 text-white',
                            yellow: 'bg-yellow-600 hover:bg-yellow-700 text-white',
                            red: 'bg-red-600 hover:bg-red-700 text-white',
                            indigo: 'bg-indigo-600 hover:bg-indigo-700 text-white',
                            purple: 'bg-purple-600 hover:bg-purple-700 text-white',
                            orange: 'bg-orange-600 hover:bg-orange-700 text-white',
                            gray: 'bg-gray-600 hover:bg-gray-700 text-white'
                          };
                          
                          return (
                            <div key={azione.id} className="border-l-4 border-blue-400 bg-blue-50 p-3 rounded-r-lg">
                              <button
                                onClick={() => handleAzione(azione.id)}
                                className={`w-full px-4 py-2 rounded-lg flex items-center text-sm font-medium transition-colors ${colorClasses[azione.color] || colorClasses.blue}`}
                              >
                                <IconComponent className="h-4 w-4 mr-3" />
                                <div className="text-left flex-1">
                                  <div className="font-medium">{azione.label}</div>
                                  {azione.descrizione && (
                                    <div className="text-xs opacity-90 mt-1">{azione.descrizione}</div>
                                  )}
                                </div>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Azioni a bassa priorità */}
                  {azioniDisponibili.filter(a => a.priorita === 'bassa').length > 0 && (
                    <div>
                      <h4 className="text-sm font-semibold text-gray-700 mb-3">Azioni Opzionali</h4>
                      <div className="space-y-2">
                        {azioniDisponibili.filter(a => a.priorita === 'bassa').map((azione) => {
                          const IconComponent = azione.icon;
                          const colorClasses = {
                            blue: 'bg-blue-600 hover:bg-blue-700 text-white',
                            green: 'bg-green-600 hover:bg-green-700 text-white',
                            yellow: 'bg-yellow-600 hover:bg-yellow-700 text-white',
                            red: 'bg-red-600 hover:bg-red-700 text-white',
                            indigo: 'bg-indigo-600 hover:bg-indigo-700 text-white',
                            purple: 'bg-purple-600 hover:bg-purple-700 text-white',
                            orange: 'bg-orange-600 hover:bg-orange-700 text-white',
                            gray: 'bg-gray-600 hover:bg-gray-700 text-white'
                          };
                          
                          return (
                            <button
                              key={azione.id}
                              onClick={() => handleAzione(azione.id)}
                              className={`w-full px-4 py-2 rounded-lg flex items-center text-sm font-medium transition-colors ${colorClasses[azione.color] || colorClasses.blue}`}
                            >
                              <IconComponent className="h-4 w-4 mr-2" />
                              <div className="text-left flex-1">
                                <div>{azione.label}</div>
                                {azione.descrizione && (
                                  <div className="text-xs opacity-80 mt-1">{azione.descrizione}</div>
                                )}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                // Layout standard per altri stati
                <div className="space-y-3">
                  {azioniDisponibili.map((azione) => {
                    const IconComponent = azione.icon;
                    const colorClasses = {
                      blue: 'bg-blue-600 hover:bg-blue-700 text-white',
                      green: 'bg-green-600 hover:bg-green-700 text-white',
                      yellow: 'bg-yellow-600 hover:bg-yellow-700 text-white',
                      red: 'bg-red-600 hover:bg-red-700 text-white',
                      indigo: 'bg-indigo-600 hover:bg-indigo-700 text-white',
                      purple: 'bg-purple-600 hover:bg-purple-700 text-white',
                      orange: 'bg-orange-600 hover:bg-orange-700 text-white',
                      gray: 'bg-gray-600 hover:bg-gray-700 text-white'
                    };
                    
                    return (
                      <button
                        key={azione.id}
                        onClick={() => handleAzione(azione.id)}
                        className={`w-full px-4 py-3 rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${colorClasses[azione.color] || colorClasses.blue}`}
                      >
                        <IconComponent className="h-4 w-4 mr-2" />
                        {azione.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Lead Originale */}
        {pratica.lead && (
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b bg-gray-50">
              <h3 className="text-lg font-semibold text-gray-900">Lead Originale</h3>
            </div>
            <div className="p-6">
              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-500">ID Lead:</label>
                  <p className="text-sm font-medium text-gray-900">{pratica.lead.id}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Data Creazione:</label>
                  <p className="text-sm font-medium text-gray-900">{formatDate(pratica.lead.dataCreazione)}</p>
                </div>
                {pratica.lead.dataCreazione && (
                  <div>
                    <label className="text-sm font-medium text-gray-500">Temperatura Lead:</label>
                    {(() => {
                      const temperaturaCalcolata = calcolaTemperaturaLead(pratica.lead.dataCreazione, pratica.lead.oraCreazione);
                      const temperaturaInfo = getTemperaturaInfo(temperaturaCalcolata);
                      return (
                        <div className="flex items-center space-x-2 mt-1">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${temperaturaInfo.badge}`}>
                            {temperaturaInfo.icon} {temperaturaCalcolata}
                          </span>
                          {temperaturaCalcolata !== pratica.lead.temperaturaLead && (
                            <span className="text-xs text-gray-500">
                              (DB: {pratica.lead.temperaturaLead})
                            </span>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabRiepilogo; 